<template>
  <AuthFormWrapper>
    <template v-if="emailSent">
      <div>
        <p>
          If a user with the email address <strong>{{ emailSent }}</strong> exists,
          you will receive an email with a link to reset your password.
        </p>

        <RouterLink
          class="link"
          :to="{ name: 'app_auth_login' }"
        >
          <FontAwesomeIcon :icon="faChevronLeft" />
          Back to Sign in
        </RouterLink>
      </div>
    </template>

    <template v-else>
      <p>
        Please enter the email address associated with your account.
        We will send you a link to reset your password.
      </p>

      <ForgotPasswordForm @email-sent="emailSent = $event" />
    </template>
  </AuthFormWrapper>
</template>

<script setup>
import { ref } from 'vue';

import { ForgotPasswordForm } from '@/components/forms';
import { AuthFormWrapper } from '@/components/wrappers';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faChevronLeft } from '@fortawesome/pro-regular-svg-icons';

let emailSent = ref();
</script>
